import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timi-department-container" }
const _hoisted_2 = { class: "timi-department-detail-content" }
const _hoisted_3 = { class: "timi-detail-column column-33" }
const _hoisted_4 = { class: "ww-data-list-item" }
const _hoisted_5 = { class: "list-item-small-text" }
const _hoisted_6 = { class: "ww-data-list-item" }
const _hoisted_7 = { class: "list-item-small-text" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "ww-card-actions" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "ww-verticale-divider" }, null, -1)
const _hoisted_11 = { class: "timi-detail-column column-33" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_CardListToggleEdit = _resolveComponent("CardListToggleEdit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconButton, {
      icon: _ctx.store.getters.svgIcons.arrowbackward,
      class: "go-back-btn",
      label: _ctx.$t('button.back'),
      dense: true,
      onOnClick: _ctx.handleGoBack
    }, null, 8, ["icon", "label", "onOnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Card, {
          title: _ctx.$t('label.department')
        }, {
          default: _withCtx(() => [
            (_ctx.department)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('label.label')), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.department.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('label.number')), 1),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.department.number), 1)
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('emptyState.default')), 1)),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Button, {
                text: _ctx.$t('button.edit'),
                dense: true,
                onOnClick: _ctx.handleEdit
              }, null, 8, ["text", "onOnClick"]),
              _hoisted_10,
              _createVNode(_component_Button, {
                text: _ctx.$t('button.delete'),
                dense: true,
                onOnClick: _ctx.handleConfirmDeleteDepartment
              }, null, 8, ["text", "onOnClick"])
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('label.employee')
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('emptyState.default')), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_CardListToggleEdit, {
          cardTitle: _ctx.$t('label.workareas'),
          arrayItems: _ctx.departmentWorkareas,
          allItems: _ctx.workareas,
          listSettings: _ctx.workareaItemSettings,
          emptyStateText: _ctx.$t('emptyState.noWorkareasAdded'),
          onOnCreateItem: _ctx.handleCreateWorkarea,
          onOnSaveItem: _ctx.handleUpdateWorkarea,
          onOnRemoveItem: _ctx.handleDeleteWorkarea
        }, null, 8, ["cardTitle", "arrayItems", "allItems", "listSettings", "emptyStateText", "onOnCreateItem", "onOnSaveItem", "onOnRemoveItem"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Card, {
          title: _ctx.$t('label.machines')
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('emptyState.default')), 1)
          ]),
          _: 1
        }, 8, ["title"])
      ])
    ])
  ]))
}